import styled from 'styled-components'

export const MobileMenu = styled.div`
  .floating-menu {
    &.lifted-up {
      margin-bottom: 50px;
    }
  }
`
